<ng-container [formGroup]="formGroup">
    <div style="" class="form-element">
        <span
            [ngClass]="{'no-line-break': hideFloatingLabel,
            'p-float-label no-line-break': !hideFloatingLabel && !isFormIdMessage,
             'custom-message-text-area-label': isFormIdMessage}">
            <ng-template [ngIf]="type===FormTypes.TEXT">
                <!--formId: {{formId}}-->
                <input id="{{formId}}"
                       type="text"
                       class="full-width"
                       [formControlName]="formId"
                       pInputText/>
            </ng-template>

            <ng-template [ngIf]="type===FormTypes.SELECT">

                <!--<i [hidden]="noListEdit" class="pi pi-pencil cursor-pointer edit-button admin-state"
                   (click)="showPropertyForm()"></i>-->
                <!--              <app-question-button [visibility]="questionVisibility" [key]="formId"
                                                   [questionEdit]="questionEdit"></app-question-button>-->
                <p-dropdown class="full-width"
                            [options]="formValues"
                            [formControlName]="formId"
                            placeholder="{{formLabel | translate}}"
                            optionValue="value"
                            optionLabel="label"
                            [filter]="filterShow"
                            [filterBy]="filterBy"
                            [showClear]="true">
                </p-dropdown>
            </ng-template>

            <ng-template [ngIf]="type===FormTypes.MULTISELECT">
<!--                <i [hidden]="noListEdit" class="pi pi-pencil cursor-pointer edit-button  admin-state"
                   (click)="showPropertyForm()"></i>-->
                <p-multiSelect class="full-width"
                               [options]="formValues"
                               [formControlName]="formId"
                               placeholder="{{formLabel | translate}}"
                               optionValue="value"
                               optionLabel="label"
                               [showClear]="true">
                </p-multiSelect>
                <!--                <app-question-button [visibility]="questionVisibility" [key]="formId"
                                                     [questionEdit]="questionEdit"></app-question-button>-->
            </ng-template>

            <ng-template [ngIf]="type===FormTypes.CALENDAR">
                  <p-calendar
                      [name]="formId"
                      [formControlName]="formId"
                      [styleClass]="calendarLeft ? 'custom-calendar' : ''"
                      [dateFormat]="dateFormat ?? 'dd.mm.yy'"
                      [inputId]="formId"/>

            </ng-template>
            <ng-template [ngIf]="type===FormTypes.TEXTAREA">

                <textarea id="{{formId}}" Style="margin-top: 20px;"
                          [name]="formId"
                          [formControlName]="formId"
                          [style]="css"
                          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                          type="text"
                          rows="5"
                ></textarea>

            </ng-template>

            <ng-template [ngIf]="type===FormTypes.CHECKBOX">
                <p-checkbox id="{{formId}}"
                            [name]="formId"
                            [formControlName]="formId"
                            [binary]="true">
                </p-checkbox>
                <!--<app-question-button [visibility]="questionVisibility"></app-question-button>-->
            </ng-template>

            <ng-template [ngIf]="type===FormTypes.RADIO">

<!--                <div class="card flex justify-content-center">
                    <div class="flex flex-column gap-3">-->
                        <div *ngFor="let item of formValues">
                        <!--<label [for]="item.value" class="ml-6">{{ item.label }}</label>-->


                                <p-radioButton
                                    [name]="formId"
                                    [inputId]="item.value"
                                    [label]="item.label"
                                    [value]="item.value"

                                    [formControlName]="formId">
                                </p-radioButton>

                            </div>
                <!--
                                </div>
                            </div>-->
            </ng-template>

            <ng-template [ngIf]="!noLabel && type !== FormTypes.CHECKBOX  && type !== FormTypes.RADIO">
                <label for="{{formId}}" class="p-ml-2">{{ formLabel | translate }}</label>
            </ng-template>
        </span>

    </div>
</ng-container>



